import { withAuthenticationRequired } from "@auth0/auth0-react";
import React, { ComponentType, memo } from "react";

interface AuthenticationGuardProps {
  component: ComponentType;
  redirectUri?: string;
}

export const AuthenticationGuard: React.FC<AuthenticationGuardProps> = memo(
  ({ component , redirectUri }) => {
    const Component = withAuthenticationRequired(component, {
      onRedirecting: () => <ft-screen-loader></ft-screen-loader>,
      returnTo : redirectUri,
    });
    return <Component />;
  }
);
